import React from 'react';
import { motion } from 'framer-motion';

const WhyChooseUs = () => {
    const reasons = [
        {
            title: "Strong Fleet & Transport Network",
            desc: "80+ professional fleet vehicles ensuring reliable, safe, and comfortable transportation services."
        },
        {
            title: "Extensive Property Solutions",
            desc: "Access to 40+ commercial offices and 90+ serviced apartments for business and residential needs."
        },
        {
            title: "International Client Support",
            desc: "Dedicated Japanese support team with a strong Pan-India service network for smooth business operations."
        }
    ];

    return (
        <section
            className="relative py-24 bg-cover bg-center bg-fixed"
            style={{ backgroundImage: "url('/team-bg.jpg')" }} // Image yahan add karein
        >
            {/* Dark Overlay for image readability */}
            <div className="absolute inset-0 bg-black/70"></div>

            <div className="relative max-w-7xl mx-auto px-6 text-center">
                <motion.h2
                    initial={{ opacity: 0, y: -30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    className="text-5xl font-extrabold text-white mb-20 drop-shadow-lg"
                >
                    Why Choose Us
                </motion.h2>

                {/* Cards Container */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {reasons.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            whileHover={{ y: -15, backgroundColor: "rgba(255, 255, 255, 0.15)" }}
                            transition={{ duration: 0.5, delay: index * 0.2 }}
                            className="bg-white/10 backdrop-blur-md p-10 border border-white/20 text-white shadow-2xl flex flex-col justify-start text-left min-h-[350px]"
                        >
                            <h4 className="text-2xl font-bold mb-6 leading-tight">{item.title}</h4>
                            <p className="text-gray-200 leading-relaxed text-sm">{item.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;